import { render, staticRenderFns } from "./courseCardOverview.vue?vue&type=template&id=511758b7&scoped=true"
import script from "./courseCardOverview.vue?vue&type=script&lang=js"
export * from "./courseCardOverview.vue?vue&type=script&lang=js"
import style0 from "./courseCardOverview.vue?vue&type=style&index=0&id=511758b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511758b7",
  null
  
)

export default component.exports